import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BotflowPlaybackState, botflowPlaybackFeatureKey } from '../reducers/botflow-playback.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';

export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, BotflowPlaybackState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);

export const selectBotflowPlaybackState = createSelector(getMainEmployeeState, state => state[botflowPlaybackFeatureKey]);

export const selectBotflowPlaybackResponse = createSelector(
  selectBotflowPlaybackState,
  (state: BotflowPlaybackState) => state.response
);

export const selectBotflowPlaybackLoading = createSelector(
  selectBotflowPlaybackState,
  (state: BotflowPlaybackState) => state.loading
);

export const selectBotflowPlaybackError = createSelector(
  selectBotflowPlaybackState,
  (state: BotflowPlaybackState) => state.error
);
